export default "__VITE_ASSET__CacH$2Yt__"